import React, { useState } from 'react';
import { Button, Col, Form, Row, Spin, Upload } from 'antd';
import { LoadingOutlined, PlusOutlined } from '@ant-design/icons';
import { IoCloseCircle } from 'react-icons/io5';
import { uploadImages } from '_components/LeadPageCommonForms/api';

type Props = {
  token: string,
  onDone: (token: string) => void,
  onCancel: () => void,
  currentValues: Object,
};

function getBase64(img, callback) {
  const reader = new FileReader();
  reader.addEventListener('load', () => callback(reader.result));
  reader.readAsDataURL(img);
}

const UploadImages = ({
  token,
  onDone,
  onCancel,
  currentValues = {},
}: Props) => {
  const [files, setFiles] = useState([
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
    null,
  ]);

  const [busy, setBusy] = useState(false);
  const uploadButton = <PlusOutlined />;

  const beforeUpload = (file, index) => {
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
    if (!isJpgOrPng) {
      message.error('You can only upload JPG/PNG file!');
      return false;
    }
    const isLt3M = file.size / 1024 / 1024 < 3;
    if (!isLt3M) {
      message.error('Image must smaller than 2MB!');
      return false;
    }

    const newFiles = [...files];

    getBase64(file, (url) => {
      newFiles[index] = {
        file,
        imageUrl: url,
      };
      setFiles(newFiles);
    });

    return false;
  };

  const removeFile = (index) => {
    const newFiles = [...files];
    newFiles[index] = null;
    setFiles(newFiles);
  };

  const onFinish = () => {
    setBusy(true);
    uploadImages(
      token,
      files.filter((f) => !!f).map((f) => f.file)
    )
      .then(function (res) {
        if (res.data.result === 'Success') {
          onDone(res.data.token);
        }
      })
      .finally(() => setBusy(false));
  };

  return (
    <Form
      className="lead-page-form opacity-95 lg:opacity-100 transition-opacity"
      onFinish={onFinish}
    >
      <Spin
        indicator={<LoadingOutlined style={{ fontSize: 24 }} spin />}
        spinning={busy}
      >
        <h3 className="text-center mb-0 font-semibold">
          {currentValues.vehicle_no}
        </h3>
        <h4 className="text-center mb-6 os-text-19">Optional Photos</h4>
        <label className="font-bold">
          Photos<span className="text-sm">(optional)</span>
        </label>
        <p>
          Select and upload exterior & interior pictures of your car and/or your
          LTA log card for a more accurate quote!
        </p>
        <Row gutter={[10, 10]} className="mt-4">
          {files.map((f, index) => (
            <Col span={8} key={index}>
              <div className="relative">
                <Upload
                  name="avatar"
                  listType="picture-card"
                  className="avatar-uploader"
                  showUploadList={false}
                  accept="image/png, image/jpeg"
                  beforeUpload={(file) => beforeUpload(file, index)}
                >
                  {f ? (
                    <img
                      src={f.imageUrl}
                      alt="avatar"
                      style={{ width: '100%' }}
                    />
                  ) : (
                    uploadButton
                  )}
                </Upload>
                {f ? (
                  <IoCloseCircle
                    className="cursor-pointer absolute"
                    style={{ top: -10, right: -10 }}
                    size={20}
                    onClick={() => removeFile(index)}
                  />
                ) : null}
              </div>
            </Col>
          ))}
        </Row>
        <Row gutter={[10, 10]} className="mt-4">
          <Col span={24}>
            <Button
              htmlType="button"
              className="w-full"
              size="large"
              onClick={onCancel}
            >
              Back
            </Button>
          </Col>
          <Col span={24}>
            <Button
              type="primary"
              htmlType="submit"
              className="get-quote-button"
              size={'large'}
            >
              Submit
            </Button>
          </Col>
        </Row>
      </Spin>
    </Form>
  );
};

export default UploadImages;
